export default {
  anonymousUser: {
    id: 'reviews_anonymous_customer',
    defaultMessage: 'An anonymous Backer',
  },
  verified: {
    id: 'product_review_display_verified',
    defaultMessage: 'Verified',
  },
  reviewInfo: {
    id: 'product_review_display_review_info',
    defaultMessage:
      'Reviewed {reviewDate}, purchased {purchaseDate}, {country}.',
  },
} as const
